import { IonCol, IonInput, IonLabel } from '@ionic/react';
import FormErrorText from '@ssg/common/Components/FormErrorText';
import { useTranslation } from 'react-i18next';
import React from 'react';

interface Props {
	label: string;
	placeholder?: string;
	onChange(value: string): void;
	value?: string | null;
	required?: boolean;
	errorMessage?: string;
	disabled?: boolean;
}

const TextInput: React.FC<Props> = ({ value, onChange, label, placeholder, required, errorMessage, disabled = false }): React.ReactElement => {
	const { t } = useTranslation();
	return (
		<IonCol size="12">
			<IonLabel className="text-blue text-base font-semibold">
				{t(label)}
				{required && <span className="text-red">*</span>}
			</IonLabel>
			<IonInput
				disabled={disabled}
				value={value}
				onIonChange={e => e.detail.value != null && onChange(e.detail.value)}
				class="rounded-md border-2 border-gray-400 p-1"
				placeholder={t(placeholder ?? '')}
			/>
			{errorMessage && <FormErrorText text={errorMessage} />}
		</IonCol>
	);
};

export default TextInput;
